import React, { useState } from 'react';
import { Upload, X } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ImageUpload = ({ onImageUploaded, currentImage }) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentImage || null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);

    // Upload
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const token = localStorage.getItem('admin_token');
      const response = await axios.post(`${BACKEND_URL}/api/admin/upload`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      const imageUrl = `${BACKEND_URL}${response.data.url}`;
      onImageUploaded(imageUrl);
      toast.success('Görsel yüklendi');
    } catch (error) {
      toast.error('Görsel yüklenirken hata oluştu');
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setPreview(null);
    onImageUploaded(null);
  };

  return (
    <div className="image-upload">
      {preview ? (
        <div className="image-upload-preview">
          <img src={preview} alt="Preview" />
          <button onClick={handleRemove} className="image-upload-remove">
            <X size={20} />
          </button>
        </div>
      ) : (
        <label className="image-upload-label">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            style={{ display: 'none' }}
          />
          <div className="image-upload-placeholder">
            <Upload size={32} />
            <p>{uploading ? 'Yükleniyor...' : 'Görsel Yükle'}</p>
          </div>
        </label>
      )}
    </div>
  );
};

export default ImageUpload;
